import React, { useState } from "react";
export default function Text({
  size,
  weight,
  color,
  children,
  hoverEffect,
  hoverColor,
  extraStyles,
  ...props
}) {
  const sizes = {
    px56: { fontSize: "56px" },
    px40: { fontSize: "40px" },
    px36: { fontSize: "36px" },
    px32: { fontSize: "32px" },
    px24: { fontSize: "24px" },
    px18: { fontSize: "18px" },
    px16: { fontSize: "16px" },
    px14: { fontSize: "14px" },
    px12: { fontSize: "12px" },
  };
  const weights = {
    w300: { fontWeight: "300" },
    w400: { fontWeight: "400" },
    w500: { fontWeight: "500" },
    w600: { fontWeight: "600" },
    w700: { fontWeight: "700" },
  };
  const colors = {
    primary: { color: "var(--primary)" },
    warning: { color: "var(--warning)" },
    danger: { color: "var(--danger)" },

    gray9: { color: "var(--gray9)" },
    gray8: { color: "var(--gray8)" },
    gray5: { color: "var(--gray5)" },
    gray4: { color: "var(--gray4)" },
    gray3: { color: "var(--gray3)" },

    greenG9: { color: "var(--greenG9)" },
    greenG7: { color: "var(--greenG7)" },
    greenG6: { color: "var(--greenG6)" },
    greenG5: { color: "var(--greenG5)" },
    greenG4: { color: "var(--greenG4)" },

    black: { color: "var(--black)" },
    white: { color: "var(--white)" },
  };
  const [isHovered, setIsHovered] = useState(false);
 
  const finalColor = (hoverEffect === 'true' && isHovered) ? hoverColor : color;
  return (
    <p
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      {...props}
      style={{
        margin: "0",
        ...sizes[size],
        ...weights[weight],
        ...colors[finalColor],
        ...extraStyles,
      }}
    >
      {children}
    </p>
  );
}
